import { scrollIt, send } from "./utils.js";
import { GOOGLE_MAPS_API, REQUEST_BIN_API } from './API';
import Typewriter from "typewriter-effect/dist/core";

const heading = document.querySelector("#typewriter");

const typewriter = new Typewriter(heading, {
  strings: "Odkryj swoje miejsce na ziemi",
  delay: 30,
  autoStart: true,
});

const cta = document.querySelector("button.cta");

const showLocation = (position) => {
  typewriter.deleteAll().typeString("Szukamy twojego miejsca").start();
  const iframe = document.createElement("iframe");
  iframe.classList.toggle("c-map");
  iframe.src = `${GOOGLE_MAPS_API}q=${position.coords.latitude},${position.coords.longitude}`;

  const iframeParent = document.querySelector(".l-main");
  iframeParent.append(iframe);

  scrollIt(iframe, 300);
  send(REQUEST_BIN_API, `${position.coords.latitude},${position.coords.longitude}`);
};
const errorHandler = (err) => {
  if (err.code == 1) {
    typewriter
      .deleteAll()
      .typeString("Potrzebujemy twojego pozwolenia")
      .pauseFor(4000)
      .deleteAll()
      .typeString("Odkryj swoje miejsce na ziemi")
      .start();
  } else if (err.code == 2) {
    typewriter
      .deleteAll()
      .typeString("Nie ma miejsa pasującego dla ciebie")
      .pauseFor(2500)
      .deleteAll()
      .typeString("Bardzo nam przykro")
      .pauseFor(4000)
      .deleteAll()
      .typeString(
        `Smells like a freak show
    Right where I want to be...`
      )
      .start();
  }
};
const getLocation = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(showLocation, errorHandler);
  } else {
    alert("Sorry, browser does not support geolocation!");
  }
};

cta.addEventListener("click", getLocation);
